import styled from 'styled-components'

export const TitleContainer = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-between;
`

export const AbsenceCardTitle = styled.h3`

`

export const TextBlock = styled.p`
    display: block;
    width: 100%;
`
